/**
 * zoomConstants — SSOT for zoom/pivot/LOD geometry (ZOOM_TRADINGVIEW_PARITY D-Z01..D-Z16).
 *
 * Both runtimes (fork KernelEngine + legacy ChartCanvas/ZoomButtons) must use
 * these values. Legacy files reference ZOOM_FACTOR in a comment and use the
 * literal 1.06 for defaultProps (no cross-package import in legacy path).
 */
/** Symmetric per-notch zoom factor (TradingView parity, D-Z04). */
export const ZOOM_FACTOR = 1.06;
/** Exponential rate: newSpan = oldSpan * exp(-ZOOM_K * step). */
export const ZOOM_K = Math.log(ZOOM_FACTOR);
/** Unified minimum visible bars (fork dynamic ~12, legacy 6 → 10, D-Z13). */
export const MIN_VISIBLE_BARS = 10;
/** Maximum visible bars (unchanged legacy cap). */
export const MAX_VISIBLE_BARS = 80_000;
/** Maximum rendered bar width in px (unchanged). */
export const SAFE_MAX_BAR_WIDTH = 80;
/** Shared-envelope bar-space bounds in px (unchanged). */
export const SHARED_ENVELOPE_MIN_BAR_SPACE_PX = 2;
export const SHARED_ENVELOPE_MAX_BAR_SPACE_PX = 64;
/**
 * Absolute right-edge anchor ratio (D-Z02, v2): when atRightEdge,
 * r = 1.0 (newTo = to). The old 0.7 lerp is REMOVED — do not restore.
 */
export const RIGHT_EDGE_ANCHOR_R = 1.0;
/** Deprecated transition width from the removed from/5 bias lerp. Kept for reference. */
export const TRANSITION_WIDTH_BARS = 5;
